// extracted by mini-css-extract-plugin
module.exports = {"image":"graphic-module--image--2rn5D"};